// Amarja Hills — BUY-ONLY single-page site.
// Light editorial luxury theme (ivory + sage + brass).
// Villa pics used ONLY in CompletedProjects; other sections use drone shots or AI imagery.

export const BUDGETS = [
  "₹6 Cr – ₹8 Cr",
  "₹8 Cr – ₹12 Cr",
  "₹12 Cr – ₹15 Cr",
  "₹15 Cr – ₹20 Cr",
  "₹20 Cr +",
];

export const SITE = {
  name: "Amarja Hills",
  phone: "+91 98215 66666",
  phoneRaw: "9821566666",
  telHref: "+919821566666",
  whatsapp: "919821566666",
  instagram: "https://www.instagram.com/amarjahills/",
  email: "info@amarjahills.com",
  logo: "/img/logo.png",
  address:
    "Nanak Properties Pvt Ltd, 501, Morya Estate, Andheri Link Road, Andheri West, Mumbai – 400058",
  estateAddress: "Mahagaon Road, Near Pawna Dam, Lonavala, Maharashtra",
  experienceUrl: "https://www.amarjaexperience.com",
};

// Real drone shots from the actual Amarja Hills estate
export const DRONE_IMAGES = [
  "/img/site/drone1.jpg",
  "/img/site/drone2.jpg",
  "/img/site/drone3.jpg",
  "/img/site/drone4.jpg",
  "/img/site/drone5.jpg",
];

// CinematicSlider — entire-project / lifestyle / aerial shots only (NO villa close-ups)
export const CINEMATIC_SLIDES = [
  { src: "/img/site/drone1.jpg", caption: "500 acres · overlooking the lake" },
  { src: "/img/site/drone2.jpg", caption: "A private hill estate" },
  { src: "/img/golf.jpg", caption: "Private golf course — coming soon" },
  { src: "/img/site/drone3.jpg", caption: "Lush green, year-round" },
  { src: "/img/clubhouse.jpg", caption: "Clubhouse · coming by December" },
  { src: "/img/site/drone4.jpg", caption: "By the silver edge of Pawna" },
  { src: "/img/resort.jpg", caption: "On-estate resort — coming by December" },
  { src: "/img/site/drone5.jpg", caption: "Where the rich & famous live" },
];

export const HIGHLIGHTS = [
  {
    id: "land",
    title: "500+ Acres of Legacy Land",
    note: "A gated hill estate overlooking the lake",
  },
  {
    id: "plots",
    title: "1, 2 & up to 5 Acre Plots",
    note: "Title-clear NA land. Privately gated.",
  },
  {
    id: "clubhouse",
    title: "Private Clubhouse, Resort & Retreat",
    note: "Coming Soon · Shared with every plot owner",
  },
  {
    id: "golf",
    title: "Private Golf Course",
    note: "Coming Soon · Championship greens on-estate",
  },
  {
    id: "helipad",
    title: "Private Helipad",
    note: "Mumbai in under thirty minutes",
  },
  {
    id: "air",
    title: "Cleanest Air You'll Ever Breathe",
    note: "Lush green canopy, year-round microclimate",
  },
];

// PLOT OFFERINGS — use drone aerials (no villa close-ups)
export const PLOTS = [
  {
    id: "plot-one",
    size: "1 Acre",
    name: "The Garden Plot",
    description:
      "An intimate parcel for a comfortable family villa, pool and garden.",
    image: "/img/site/drone3.jpg",
  },
  {
    id: "plot-two",
    size: "2 Acres",
    name: "The Estate Plot",
    description:
      "Generous grounds for a farmhouse, pool, orchard and outdoor lounge.",
    image: "/img/site/drone2.jpg",
    featured: true,
  },
  {
    id: "plot-five",
    size: "Up to 5 Acres",
    name: "The Legacy Estate",
    description:
      "A complete private estate with main villa, guest house, orchard and lawn.",
    image: "/img/site/drone4.jpg",
  },
];

// CONSTRUCTION STYLES — used in VillaTypes section (between Plots and Amenities).
// AI-generated imagery only — none of these reuse the real villa photos from CompletedProjects.
export const VILLA_STYLES = [
  {
    id: "rcc",
    name: "RCC",
    tagline: "Modern · monolithic",
    description:
      "Clean lines, enduring concrete. Modern and monolithic — built for the long haul.",
    image: "/img/concrete.jpg",
  },
  {
    id: "russian-log",
    name: "Russian Log House",
    tagline: "Hand-hewn timber",
    description:
      "Hand-hewn pine logs, deep eaves, copper rain chains. Warm interiors for cool hill nights.",
    image: "/img/wooden.jpg",
  },
  {
    id: "hybrid",
    name: "Hybrid",
    tagline: "Concrete + wood",
    description:
      "Concrete shell, timber soul. The best of both worlds — modern bones, warm skin.",
    image: "/img/hybrid.jpg",
  },
  {
    id: "portugese",
    name: "Portugese",
    tagline: "Old-world charm",
    description:
      "Arched windows, terracotta tiles, whitewash. Old-world Iberian charm on a hilltop.",
    image: "/img/portugese.jpg",
  },
];

// COMPLETED PROJECTS — 7 real homes already built on-estate.
// Images use natural aspect (no crop). All 7 distinct shots.
export const COMPLETED_PROJECTS = [
  {
    id: "villa-01",
    number: "Villa 01",
    name: "Casa Lonavala",
    style: "Modern Wood · Infinity Pool",
    image: "/img/projects/p1.jpg",
  },
  {
    id: "villa-02",
    number: "Villa 02",
    name: "The Chalet House",
    style: "Wooden Gabled · Daylight",
    image: "/img/projects/p3.jpg",
  },
  {
    id: "villa-03",
    number: "Villa 03",
    name: "Casa Colonial",
    style: "Colonial · Mountain View",
    image: "/img/projects/p4.jpg",
  },
  {
    id: "villa-04",
    number: "Villa 04",
    name: "Villa Mirador",
    style: "Modern RCC · Lap Pool",
    image: "/img/projects/p5.jpg",
  },
  {
    id: "villa-05",
    number: "Villa 05",
    name: "Casa Sereno",
    style: "Russian Log · Twilight",
    image: "/img/projects/p2.jpg",
  },
  {
    id: "villa-06",
    number: "Villa 06",
    name: "The Lake House",
    style: "Modern RCC · Infinity Pool",
    image: "/img/site/villa-rcc.jpg",
  },
  {
    id: "villa-07",
    number: "Villa 07",
    name: "The White House",
    style: "Portugese · Hilltop",
    image: "/img/site/villa-portugese.jpg",
  },
];

// AMENITIES — Wellness + Equestrian now use AI-generated imagery (not villa pics).
export const AMENITIES = [
  {
    id: "clubhouse",
    title: "The Clubhouse",
    line: "A shared amenity",
    status: "Coming by December",
    image: "/img/clubhouse.jpg",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    id: "golf",
    title: "Private Golf Course",
    line: "Championship greens",
    status: "Coming Soon",
    image: "/img/golf.jpg",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    id: "resort",
    title: "On-Estate Resort",
    line: "Hospitality at your doorstep",
    status: "Coming by December",
    image: "/img/resort.jpg",
    span: "lg:col-span-2",
  },
  {
    id: "spa",
    title: "The Spa",
    line: "A sanctuary for the senses",
    status: "Coming by December",
    image: "/img/spa.jpg",
    span: "lg:col-span-2",
  },
  {
    id: "wellness",
    title: "Wellness Center",
    line: "Yoga · Pilates · Therapy",
    status: "Coming by December",
    image: "/img/wellness.jpg",
    span: "lg:col-span-2",
  },
  {
    id: "equestrian",
    title: "Equestrian Center",
    line: "Stables · Riding trails",
    status: "Coming by December",
    image: "/img/equestrian.jpg",
    span: "lg:col-span-3",
  },
  {
    id: "helipad",
    title: "Private Helipad",
    line: "Mumbai in under 30 minutes",
    status: "Operational",
    image: "/img/helipad.jpg",
    span: "lg:col-span-3",
  },
];

// Exact distances specified by client
export const CONNECTIVITY = [
  { time: "15 min", place: "Mumbai-Pune Expressway" },
  { time: "49 km", place: "Pune" },
  { time: "99 km", place: "Mumbai" },
  { time: "57 min", place: "Navi Mumbai Airport" },
  { time: "60 min", place: "Atal Setu" },
  { time: "05 min", place: "Pawna Lake" },
];
